<template>
  <div class="sectionBox1">
    <div class="topBox">
      <van-nav-bar title="我的订单" left-arrow @click-left="onClickLeft" />
      <div class="mainBox">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="first"></el-tab-pane>
          <el-tab-pane label="待发货" name="second"></el-tab-pane>
          <el-tab-pane label="已发货" name="third"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="conBox">
      <!-- orderList -->
      <div class="box_item" v-for="item of orderList" :key="item.id">
        <div class="line01">
          <!-- <img class="payTypeImg" v-if="item.payType == 2" src="../../assets/shopping/wechat.png" />
          <img v-if="item.payType == 3" class="payTypeImg" src="../../assets/shopping/alipay.png" />-->
          <div class="buyTime">{{ item.buyTime }}</div>
          <el-tag class="tags" v-if="item.issue == 0" size="mini" type="info">
            待发货
          </el-tag>
          <el-tag class="tags" v-if="item.issue == 1" size="mini">
            已发货
          </el-tag>
        </div>
        <div class="line02">
          <div class="shopImg">
            <el-image
              style="width: 100%; height: 100%"
              :src="item.shopAdminModel.shopUrl"
              fit="cover"
            ></el-image>
          </div>
          <div class="contBox">
            <div class="shopName" style="margin-top: 2px">
              {{ item.shopName ? item.shopName : "---" }}
            </div>
            <div class="buyNum">
              购买数量:{{ item.buyNumber ? item.buyNumber : 0 }}个
            </div>
            <div style="margin-top: 2px; height: 22px">
              <div class="shopPrice">
                ￥
                <span style="font-size: 20px">
                  {{ item.money ? item.money : 0 }}
                </span>
              </div>
              <div class="shopNum">
                快递费:{{ item.orderPostAge ? item.orderPostAge : 0 }}元
              </div>
              <div class="arrowBtn">
                <i
                  @click="item.showBox = true"
                  v-if="!item.showBox"
                  class="el-icon-arrow-down"
                ></i>
                <i
                  @click="item.showBox = false"
                  v-if="item.showBox"
                  class="el-icon-arrow-up"
                ></i>
              </div>
            </div>
          </div>
          <div
            v-if="item.showBox"
            :class="!item.showBox ? 'hideBoxs' : 'showBoxs'"
          >
            <div class="showBoxs_in">
              <div class="title">订单信息</div>
              <div class="infos">
                <div class="info_item">
                  <div class="left">姓名</div>
                  <div class="right">
                    {{ item.userName ? item.userName : "---" }}
                  </div>
                </div>
                <div class="info_item">
                  <div class="left">手机号</div>
                  <div class="right">
                    {{ item.userPhone ? item.userPhone : "---" }}
                  </div>
                </div>
                <div class="info_item">
                  <div class="left">收货地址</div>
                  <div class="right">
                    {{ item.buyAddress ? item.buyAddress : "---" }}
                  </div>
                </div>
                <div class="info_item">
                  <div class="left">支付方式</div>
                  <div class="right">
                    {{ item.payTypeName ? item.payTypeName : "---" }}
                  </div>
                </div>
                <div class="info_item">
                  <div class="left">订单编号</div>
                  <div class="right">
                    {{ item.orderNumber ? item.orderNumber : "---" }}
                  </div>
                </div>
                <div class="info_item">
                  <div class="left">快递公司</div>
                  <div class="right">
                    {{ item.expressName ? item.expressName : "---" }}
                  </div>
                </div>
                <div class="info_item">
                  <div class="left">快递单号</div>
                  <div class="right">
                    {{ item.expressNumber ? item.expressNumber : "---" }}
                  </div>
                </div>
                <div class="info_item">
                  <div class="left">订单备注</div>
                  <div class="right">
                    {{ item.orderRemark ? item.orderRemark : "---" }}
                  </div>
                </div>
                <div class="info_item">
                  <div class="left">返回信息</div>
                  <div class="right">
                    {{ item.issueRemark ? item.issueRemark : "---" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="more">
        {{
          queryForm.page >= totalPage ? "暂无更多数据..." : "加载更多数据..."
        }}
      </div>
    </div>
  </div>
</template>

<script>
  import { getOrderLists, getPayTypeAll } from "@/api/shopping";
  export default {
    data() {
      return {
        activeName: "first",
        payTypeList: [],
        queryForm: {
          page: 1,
          size: 10,
        },
        orderList: [],
        totalPage: 1,
        userPhone: "",
        issue: "",
      };
    },
    mounted() {
      this.$nextTick(() => {
        // 监听滚动事件
        //类名为guest-info-box的div必须设置高度和 overflow-y: scroll;下面的代码才会生效
        let scrollTargetBox = document.querySelector(".conBox");
        scrollTargetBox.onscroll = () => {
          var scrollHeight = scrollTargetBox.scrollHeight; //251
          var scrollTop = scrollTargetBox.scrollTop; //0-18
          var clientHeight = scrollTargetBox.clientHeight; //233
          if (scrollHeight - clientHeight == scrollTop) {
            //滚动条滚到最底部
            if (this.queryForm.page >= this.totalPage) return;
            this.queryForm.page++;
            this.getOrderLists();
          }
        };
      });
      this.getPayTypeAll();
      this.userPhone = localStorage.getItem("userPhone");
      this.getOrderLists();
    },
    created() {},
    methods: {
      // 返回
      onClickLeft() {
        localStorage.setItem("userPhone", "");
        history.back();
      },
      handleClick(tab, event) {
        console.log(tab, event);
        this.orderList = [];
        this.totalPage = 1;
        if (tab.index == "0") {
          this.issue = "";
        } else if (tab.index == "1") {
          this.issue = 0;
        } else if (tab.index == "2") {
          this.issue = 1;
        }
        this.getOrderLists();
      },
      // 查询订单列表
      getOrderLists() {
        let params = {
          userPhone: this.userPhone,
          issue: this.issue,
        };
        getOrderLists(this.queryForm, params).then((res) => {
          if (res.status) {
            //  console.log(res.data)
            if (res.data && res.data.list && res.data.list.length) {
              for (let i = 0; i < res.data.list.length; i++) {
                res.data.list[i].showBox = false;
                for (let j = 0; j < this.payTypeList.length; j++) {
                  if (res.data.list[i].payType == this.payTypeList[j].payType) {
                    res.data.list[i].payTypeName = this.payTypeList[j].payName;
                  }
                }
              }
              this.orderList = [...this.orderList, ...res.data.list];
              this.totalPage = res.data.totalPage;
              // console.log(this.orderList);
            }
          } else {
            this.$toast(res.msg);
          }
        });
      },
      // 查询支付类型
      getPayTypeAll() {
        getPayTypeAll().then((res) => {
          if (res.status) {
            //  console.log(res.data)
            if (res.data && res.data.length >= 0) {
              this.payTypeList = res.data;
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss">
  .van-nav-bar__left {
    .van-icon {
      color: #323233 !important;
    }
  }
  .sectionBox1 {
    height: 100vh;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    .topBox {
      width: 100%;
      position: fixed;
      top: 0px;
      z-index: 10;
      .mainBox {
        margin: 0px;
        padding: 0px;
        background-color: #fff !important;
        .el-tabs__header {
          margin-bottom: 5px;
        }
        .el-tabs__nav-scroll {
          text-align: center !important;
        }
        .el-tabs__nav,
        .is-top {
          clear: both !important;
          display: inline-block !important;
        }

        .el-tabs__nav-wrap::after {
          background-color: transparent !important;
        }
        .el-tabs__content {
          display: none;
          // background-color: #f5f5f5 !important;
          // padding: 10px !important;
          // height: 100vh;
        }
      }
    }
    .more {
      clear: both;
      text-align: center;
      // color: #1b8bff;
      font-size: 12px;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .conBox {
      clear: both;
      position: relative;
      top: 93px;
      background-color: #f5f5f5 !important;
      height: calc(100% - 133px);
      padding: 20px 15px;
      z-index: 1;
      overflow: auto;
      .box_item {
        margin-bottom: 20px;
        min-height: 120px;
        border-radius: 10px;
        background-color: #fff;
        .line01 {
          padding: 5px 10px;
          height: 30px;
          font-size: 13px;
          // .payTypeImg {
          //   margin: 5px 0px;
          //   float: left;
          //   width: 20px;
          //   height: 20px;
          // }
          .buyTime {
            float: left;
            height: 30px;
            line-height: 30px;
            // margin-left: 10px;
            width: calc(100% - 70px);
            // width: calc(100% - 90px);
            font-size: 14px;
            text-align: left;
            color: #515151;
          }
          .tags {
            float: right;
            width: 50px;
            margin-left: 10px;
            margin: 5px 0px;
          }
        }
        .line02 {
          border-top: 1px solid #ededed;
          text-align: left;
          // margin: 10px 0px;
          min-height: 60px;
          padding: 10px 10px;
          .shopImg {
            float: left;
            width: 60px;
            height: 60px;
            margin-right: 5px;
            border-radius: 10px;
            overflow: hidden;
            margin-bottom: 10px;
          }
          .contBox {
            float: right;
            width: calc(100% - 65px);
            margin-bottom: 10px;
            .shopName {
              font-size: 16px;
              font-weight: 500;
              color: #4f4f4f;
              // margin-bottom: 0px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .buyNum {
              color: #979797;
              font-size: 12px;
            }
            .shopPrice {
              float: left;
              color: #1b8bff;
              font-size: 12px;
              width: 60%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .shopNum {
              float: left;
              margin-top: 3px;
              color: #979797;
              font-size: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 29%;
              text-align: right;
            }
            .arrowBtn {
              float: left;
              margin-left: 1%;
              font-size: 20px;
              width: 10%;
              text-align: right;
            }
          }
          .hideBoxs {
            display: none;
          }
          .showBoxs {
            display: block;
            clear: both;
            border-top: 1px solid #addaff;
            padding: 10px 0px 0px;
            margin-top: 10px;
            .showBoxs_in {
              background-color: #f5f5f5;
              border-radius: 10px;
              .title {
                text-align: center;
                border-bottom: 1px solid #addaff;
                height: 30px;
                line-height: 30px;
              }
              .infos {
                padding: 10px 20px 5px;
                .info_item {
                  padding-bottom: 5px;
                  .left {
                    display: inline-block;
                    width: 65px;
                    color: #000000;
                    text-align: left;
                    font-size: 12px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  .right {
                    display: inline-block;
                    width: calc(100% - 65px);
                    color: #656565;
                    text-align: left;
                    font-size: 12px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
